import { AdminRole, AppRoutes, SideBarLink } from '../../types/constants.types';
import { canAccessWebsiteCms, isWebsiteCmsRestrictedPath, WEBSITE_CMS_EXTERNAL_URL } from './cmsAccess';

import { HiArchive, HiOutlineViewGrid, HiSparkles, HiTruck, HiUsers } from 'react-icons/hi'
import { SlEnergy, SlLogout, SlNote, SlSettings, SlSupport} from 'react-icons/sl'
import { BiSolidDonateHeart } from "react-icons/bi";
import { FaChartLine, FaRegMoneyBillAlt, FaTv, FaQrcode, FaShareAlt, FaRegEnvelope } from "react-icons/fa";

export type SideBarSection = {
    key: string;
    label: string;
    links: SideBarLink[];
};

const DASHBOARD_SIDEBAR_LINK:SideBarLink[] = [
    {
        key:'Dashboard',
        label: 'Dashboard',
        path: AppRoutes.DASHBOARD,
        active: true,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <HiOutlineViewGrid />
    },
    {
        key:'Campaigns',
        label: 'Campaigns',
        path: AppRoutes.CAMPAIGN,
        active: false,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <HiArchive />
    },
    {
        key:'Promotions',
        label: 'Promotions',
        path: AppRoutes.PROMOTIONS,
        active: true,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <FaQrcode />
    },
    {
        key:'Donations',
        label: 'Donations',
        path: AppRoutes.DONATIONS,
        active: false,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <BiSolidDonateHeart />
    },
    {
        key:'Funds',
        label: 'Funds & Pledges',
        path: AppRoutes.FUNDS,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER],
        icon:  <FaRegMoneyBillAlt />
    },
    {
        key:'Shipments',
        label: 'Shipments',
        path: AppRoutes.SHIPMENTS,
        active: false,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <HiTruck />
    },
    {
        key:'ShipmentAlerts',
        label: 'Shipment Alerts',
        path: '/shipment_alerts',
        active: false,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <SlNote />
    },
    {
        key:'Users',
        label: 'Users',
        path: AppRoutes.USERS,
        active: true,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <HiUsers />
    },
    {
        key:'SiteRequests',
        label: 'Website Requests',
        path: AppRoutes.SITE_REQUESTS,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER],
        icon:  <FaRegEnvelope />
    },
    {
        key:'KioskRegistrations',
        label: 'Channel Registrations',
        path: AppRoutes.KIOSK_REGISTRATIONS,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER],
        icon:  <HiUsers />
    },
    {
        key:'WaitlistQrManagement',
        label: 'Waitlist QR Management',
        path: AppRoutes.WAITLIST_QR_MANAGEMENT,
        active: true,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <FaQrcode />
    },
    {
        key:'Referrals',
        label: 'Referrals',
        path: AppRoutes.REFERRALS,
        active: true,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <HiSparkles />
    },
    {
        key:'Kiosks',
        label: 'Kiosks',
        path: AppRoutes.KIOSKS,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER],
        icon:  <FaTv />
    },
    {
        key:'KioskConfiguration',
        label: 'Kiosk CMS',
        path: AppRoutes.KIOSK_CONFIGURATION,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER],
        icon:  <FaTv />
    },
    {
        key:'WebsiteCMS',
        label: 'Website Editor',
        path: WEBSITE_CMS_EXTERNAL_URL,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER],
        isExternal: true,
        icon:  <SlNote />
    },
    {
        key:'KioskPerformance',
        label: 'Kiosk Performance',
        path: AppRoutes.KIOSK_PERFORMANCE,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER],
        icon:  <FaChartLine />
    },
    {
        key:'OwnerReportingPayoutSettings',
        label: 'Account Settings',
        path: AppRoutes.OWNER_REPORTING_PAYOUT_SETTINGS,
        active: true,
        allowedRoles: [AdminRole.KIOSK_OWNER],
        icon:  <SlSettings />
    },
    {
        key:'OwnerRewards',
        label: 'Rewards',
        path: AppRoutes.OWNER_REWARDS,
        active: true,
        allowedRoles: [AdminRole.KIOSK_OWNER],
        icon:  <FaRegMoneyBillAlt />
    },
    {
        key:'SocialMediaCampaign',
        label: 'Social Media',
        path: AppRoutes.SOCIAL_MEDIA_CAMPAIGN,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER],
        icon: <FaShareAlt />
    },
    {
        key:'KioskBilling',
        label: 'Kiosk Billing',
        path: AppRoutes.KIOSK_BILLING,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER],
        icon:  <FaRegMoneyBillAlt />
    },
    {
        key:'OwnerPayoutRequests',
        label: 'Owner Payout Requests',
        path: AppRoutes.OWNER_PAYOUT_REQUESTS,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER],
        icon:  <FaRegMoneyBillAlt />
    },
    {
        key:'SupportRequests',
        label: 'Support Requests',
        path: AppRoutes.SUPPORT_REQUESTS,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER],
        icon:  <SlEnergy />
    },
]

const getLinkByKey = (key: string): SideBarLink => {
    const link = DASHBOARD_SIDEBAR_LINK.find((l) => l.key === key);
    if (!link) {
        throw new Error(`Sidebar link with key ${key} not found`);
    }
    return link;
};

export const DASHBOARD_SIDEBAR_SECTIONS: SideBarSection[] = [
    {
        key: 'overview',
        label: 'Overview',
        links: [
            getLinkByKey('Dashboard'),
            getLinkByKey('KioskPerformance'),
        ],
    },
    {
        key: 'growth',
        label: 'Growth & Campaigns',
        links: [
            getLinkByKey('Campaigns'),
            getLinkByKey('Promotions'),
            getLinkByKey('Donations'),
            getLinkByKey('Funds'),
            getLinkByKey('Referrals'),
            getLinkByKey('SocialMediaCampaign'),
        ],
    },
    {
        key: 'operations',
        label: 'Operations',
        links: [
            getLinkByKey('Shipments'),
            getLinkByKey('ShipmentAlerts'),
            getLinkByKey('KioskBilling'),
            getLinkByKey('OwnerPayoutRequests'),
            getLinkByKey('SupportRequests'),
        ],
    },
    {
        key: 'platform',
        label: 'Platform',
        links: [
            getLinkByKey('Kiosks'),
            getLinkByKey('KioskConfiguration'),
            getLinkByKey('WebsiteCMS'),
            getLinkByKey('OwnerReportingPayoutSettings'),
            getLinkByKey('OwnerRewards'),
        ],
    },
    {
        key: 'admin',
        label: 'Admin',
        links: [
            getLinkByKey('Users'),
            getLinkByKey('SiteRequests'),
            getLinkByKey('KioskRegistrations'),
            getLinkByKey('WaitlistQrManagement'),
        ],
    },
];

export const DASHBOARD_SIDEBAR_BOTTOM_LINK = [
    {
        key:'Settings',
        label: 'Settings',
        path: '/settings',
        active: false,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <SlSettings />
    },
    {
        key:'Help',
        label: 'Help & Support',
        path: '/support',
        active: false,
        allowedRoles: [AdminRole.ADMIN],
        icon:  <SlSupport />
    },
    {
        key:'Logout',
        label: 'Logout',
        path: AppRoutes.LOGOUT,
        active: true,
        allowedRoles: [AdminRole.ADMIN, AdminRole.T2F_MANAGER, AdminRole.KIOSK_OWNER],
        icon:  <SlLogout />
    },
]

export const canAccessByRole = (role: string | undefined | null, allowedRoles?: string[]) => {
    if (!allowedRoles || allowedRoles.length === 0) {
        return true;
    }

    if (!role) {
        return false;
    }

    return allowedRoles.includes(role.toUpperCase());
};

const canAccessByTemporaryCmsGate = (path: string, email: string | undefined | null) => {
    if (!isWebsiteCmsRestrictedPath(path)) {
        return true;
    }

    return canAccessWebsiteCms(email);
};

export const getSidebarLinksByRole = (
    role: string | undefined | null,
    email?: string | undefined | null,
) => {
    return DASHBOARD_SIDEBAR_LINK.filter(
        (item) => canAccessByRole(role, item.allowedRoles) && canAccessByTemporaryCmsGate(item.path, email),
    );
};

export const getSidebarSectionsByRole = (
    role: string | undefined | null,
    email?: string | undefined | null,
) => {
    return DASHBOARD_SIDEBAR_SECTIONS
        .map((section) => ({
            ...section,
            links: section.links.filter(
                (item) => canAccessByRole(role, item.allowedRoles) && canAccessByTemporaryCmsGate(item.path, email),
            ),
        }))
        .filter((section) => section.links.length > 0);
};

export const getSidebarBottomLinksByRole = (role: string | undefined | null) => {
    return DASHBOARD_SIDEBAR_BOTTOM_LINK.filter((item) => canAccessByRole(role, item.allowedRoles));
};
